import { observer } from 'mobx-react';
import React, { useEffect } from 'react';

import { useStores } from '@/hooks/use-stores';

import { activeTabs } from '../Insights';
import BottomSection from './BottomSection';
import { OverviewContainer } from './styled';
import TopSection from './TopSection';

const OverviewTab = observer(({ activeTab, animation = true }: { activeTab: string; animation?: boolean }) => {
  const { insightsStore } = useStores();
  const { overview: { total, actionsTaken, actionsPending } = { total: {}, actionsTaken: {}, actionsPending: {} } } =
    insightsStore;

  useEffect(() => {
    activeTab === activeTabs.overview && insightsStore.getOverview();
  }, [activeTab, insightsStore.rootStore.stationStore?.currentStation?.id]);

  return (
    <OverviewContainer>
      <div className="vd-insights-overview-content">
        <TopSection total={total} animation={animation} isLoading={insightsStore.isLoading} />
        <hr className="horizontal-line" />
        <BottomSection
          actionsTaken={actionsTaken}
          actionsPending={actionsPending}
          isLoading={insightsStore.isLoading}
        />
      </div>
    </OverviewContainer>
  );
});

export default OverviewTab;
